import NaruckoLogoBlack from '@assets/narucko-logo-black.svg';
import NaruckoLogoWhite from '@assets/narucko-logo-white.svg';
import { Box, useScrollTrigger } from '@mui/material';
import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

interface HeaderIconProps {
}

const HeaderIcon: React.FC<HeaderIconProps> = ({ }) => {
    const navigate = useNavigate();
    const { pathname } = useLocation();
    return (
        <ElevationScroll pathName={pathname}>
            <Box
                onClick={() => navigate("/")}
                component="img"
                sx={{
                    width: { xs: 100, sm: 110, md: 150 },
                }}
                alt="logo"
                src={NaruckoLogoBlack}
            />
        </ElevationScroll>
    )
}

export default HeaderIcon;

interface Props {
    children: React.ReactElement;
    pathName: string;
}

function ElevationScroll(props: Props) {
    const { children } = props;
    const trigger = useScrollTrigger({
        disableHysteresis: true,
        threshold: 0,
    });

    if (props.pathName === "/" || (props.pathName.includes("/restaurant") && props.pathName.includes("/offer"))) {
        if (trigger) {
            return React.cloneElement(children, {
                src: NaruckoLogoBlack
            });
        }
        else {
            return React.cloneElement(children, {
                src: NaruckoLogoWhite
            });
        }
    }

    return React.cloneElement(children, {
        src: NaruckoLogoBlack
    });
}